import client from './client';

export interface UploadedFileResponse {
  uploadId?: string;
  fileUrl: string;
  originalFilename: string;
  contentType: string;
  size: number;
}

type RawUploadResponse = {
  uploadId?: string;
  url?: string;
  fileUrl?: string;
  originalFilename: string;
  contentType: string;
  size: number;
};

function normalizeUploadResponse(data: RawUploadResponse): UploadedFileResponse {
  return {
    uploadId: data.uploadId,
    fileUrl: data.fileUrl ?? data.url ?? '',
    originalFilename: data.originalFilename,
    contentType: data.contentType,
    size: data.size,
  };
}

async function postUpload(path: string, file: File): Promise<UploadedFileResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await client.post<RawUploadResponse>(path, formData);
  return normalizeUploadResponse(response.data);
}

export const uploadApi = {
  uploadProductImage: (file: File) => postUpload('/uploads/products', file),
  uploadSupplyImage: (file: File) => postUpload('/uploads/supplies', file),
  uploadVariantImage: (file: File) => postUpload('/uploads/variants', file),
  uploadInventoryImage: (file: File) => postUpload('/uploads/inventory', file),
  uploadProductDesignFile: (file: File) => postUpload('/uploads/designs/products', file),

  finalizeMedia: async (data: {
    url: string;
    entityType: 'PRODUCT' | 'SUPPLY' | 'VARIANT';
    entityId: string;
    displayName?: string;
    primary?: boolean;
  }) => {
    const response = await client.post('/uploads/finalize', data);
    return response.data;
  },

  deleteFile: async (url: string): Promise<void> => {
    await client.delete('/uploads', { params: { url } });
  },
};

export function classifyDesignFile(filename: string): 'model' | 'design' {
  const lower = filename.toLowerCase();
  if (lower.endsWith('.stl') || lower.endsWith('.3mf')) {
    return 'model';
  }
  return 'design';
}
